import React from "react";
import InStock from "../InStock/InStock";
import OutOfStock from "../OutOfStock/OutOfStock";
import styled from "styled-components";

const Availability = ({ availability }) => (
  <StyledAvailability>
    {availability > 0 ? (
      <InStock availability={availability} />
    ) : (
      <OutOfStock />
    )}
  </StyledAvailability>
);

export default Availability;

const StyledAvailability = styled.div`
  margin-top: 40px;
`;
